import { Box, BoxProps, createStyles, CSSObject } from "@mantine/core";
import React from "react";
import { PolymorphicComponentProps } from "@mantine/utils";

interface FlexProps {
  direction?: CSSObject["flexDirection"];
  justify?: CSSObject["justifyContent"];
  align?: CSSObject["alignItems"];
  gap?: CSSObject["gap"];
  wrap?: CSSObject["flexWrap"];
  flex?: CSSObject["flex"];
  fullWidth?: boolean;
}

export type ExtendedFlexProps = FlexProps & PolymorphicComponentProps<"div", BoxProps>;

export const useFlexStyles = createStyles<"root", FlexProps>(
  (_, { direction, justify, align, gap, wrap, flex, fullWidth }) => {
    return {
      root: {
        display: "flex",
        flexDirection: direction,
        justifyContent: justify,
        alignItems: align,
        gap: gap,
        flexWrap: wrap,
        flex: flex,
        ...(fullWidth && { width: "100%" }),
      },
    };
  }
);

type FlexType = React.FC<ExtendedFlexProps> & {
  Row: React.FC<Omit<ExtendedFlexProps, "direction">>;
  Column: React.FC<Omit<ExtendedFlexProps, "direction">>;
};

export const Flex: FlexType = ({ direction, justify, align, gap, fullWidth, className, ...props }) => {
  const { classes, cx } = useFlexStyles({ direction, justify, align, gap, fullWidth });
  return <Box className={cx(classes.root, className)} {...props} />;
};

Flex.Row = (props) => <Flex direction="row" {...props} />;
Flex.Column = (props) => <Flex direction="column" {...props} />;
